import { nextTick } from "vue";

// 过滤对象空字段
function filterEmptyStrings(obj) {
  const filteredObj = {};

  Object.keys(obj).forEach((key) => {
    if (obj[key] !== "" && obj[key] !== null && obj[key] !== undefined) {
      filteredObj[key] = obj[key];
    }
  });

  return filteredObj;
}

// 获取当前日期时间 和 昨天 明天
function useCurrentDateTime() {
  let currentDate = "";
  let currentTime = "";
  let yesterday = "";
  let tomorrow = "";

  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const date = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  currentDate = `${year}-${month}-${date}`;
  currentTime = `${hours}:${minutes}:${seconds}`;

  // 计算昨天的日期
  const yesterdayDate = new Date(now);
  yesterdayDate.setDate(now.getDate() - 1);
  const yesterdayYear = yesterdayDate.getFullYear();
  const yesterdayMonth = String(yesterdayDate.getMonth() + 1).padStart(2, "0");
  const yesterdayDay = String(yesterdayDate.getDate()).padStart(2, "0");
  yesterday = `${yesterdayYear}-${yesterdayMonth}-${yesterdayDay}`;

  // 计算明天的日期
  const tomorrowDate = new Date(now);
  tomorrowDate.setDate(now.getDate() + 1);
  const tomorrowYear = tomorrowDate.getFullYear();
  const tomorrowMonth = String(tomorrowDate.getMonth() + 1).padStart(2, "0");
  const tomorrowDay = String(tomorrowDate.getDate()).padStart(2, "0");
  tomorrow = `${tomorrowYear}-${tomorrowMonth}-${tomorrowDay}`;

  // onMounted(() => {
  //     updateDateTime();
  //     setInterval(updateDateTime, 1000);
  // });

  return { currentDate, currentTime, yesterday, tomorrow };
}

// 时间戳转日期 yyyy-mm-dd
function formatDate(date) {
  const year = String(date.getFullYear()).padStart(4, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/**
 * 获取指定日期是星期几
 *
 * @param {string} dateString - 日期字符串，格式为 'YYYY-MM-DD'
 * @returns {string} - 返回日期对应的星期几（例如：'星期三'）
 */
function getDayOfWeek(dateString) {
  // 创建一个Date对象
  const date = new Date(dateString);

  // 获取星期几，返回值是0（星期日）到6（星期六）
  const dayOfWeek = date.getDay();

  // 定义一个数组，包含一周的所有天
  const days = [
    "星期日",
    "星期一",
    "星期二",
    "星期三",
    "星期四",
    "星期五",
    "星期六",
  ];

  // 返回对应的星期几
  return days[dayOfWeek];
}

/**
 * 判断输入的日期时间是否在当前日期时间之后
 * @param {string} dateTime - 需要比较的日期时间字符串
 * @returns {boolean} - 如果输入日期时间在当前日期时间之后，则返回 true；否则返回 false
 */
export function isAfterNow(dateTime) {
  // 将输入的日期时间字符串转换为 Date 对象
  const inputDate = new Date(dateTime);

  // 获取当前的日期时间
  const now = new Date();

  // 比较输入的日期时间和当前的日期时间
  return inputDate > now;
}

// 返回两个日期之间的间隔天数
function getDaysBetweenDates(date1, date2) {
  // 将日期字符串转换为Date对象
  const startDate = new Date(date1);
  const endDate = new Date(date2);

  // 计算两个日期的时间差（毫秒）
  const timeDifference = endDate - startDate;

  // 将时间差转换为天数
  const daysDifference = timeDifference / (1000 * 3600 * 24);

  // 返回天数差的绝对值
  return Math.abs(daysDifference);
}

/**
 * 计算指定日期之后的指定天数后的日期
 *
 * @param {string} dateString - 起始日期，格式为 'YYYY-MM-DD'
 * @param {number} days - 要添加的天数
 * @returns {string} - 计算后的日期，格式为 'YYYY-MM-DD'
 */
function addDaysToDate(dateString, days) {
  const date = new Date(dateString);
  date.setDate(date.getDate() + days);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始，需要加1并确保两位数
  const day = String(date.getDate()).padStart(2, "0"); // 日确保为两位数
  return `${year}-${month}-${day}`;
}

// 将元素滚动到视口位置
function scrollIntoView(el) {
  if (!el) return;
  // 如果已经在视口内则不滚动
  if (
    el.getBoundingClientRect().top >= 0 &&
    el.getBoundingClientRect().bottom <= window.innerHeight
  ) {
    return;
  }
  nextTick(() => {
    el.scrollIntoView({
      behavior: "smooth",
      block: "nearest", // 避免整个容器滚动超出视口
      inline: "nearest",
    });
  });
}

// 解析身份证返回基本信息
function parseIDCard(idCard) {
  // 校验身份证号码格式
  if (!/^\d{17}(\d|X|x)$/.test(idCard)) {
    return {};
  }

  // 解析身份证信息
  const areaCode = idCard.substring(0, 6);
  const birthYear = idCard.substring(6, 10);
  const birthMonth = idCard.substring(10, 12);
  const birthDay = idCard.substring(12, 14);
  const sequenceCode = idCard.substring(14, 17);
  const genderCode = parseInt(idCard.substring(16, 17), 10);
  const checkDigit = idCard.substring(17, 18).toUpperCase();

  // 计算性别
  const gender = genderCode % 2 === 0 ? "女" : "男";

  // 计算年龄
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1; // JavaScript中的月份是从0开始的，所以要加1
  const currentDay = new Date().getDate();

  let age = currentYear - parseInt(birthYear, 10);
  if (
    currentMonth < parseInt(birthMonth, 10) ||
    (currentMonth === parseInt(birthMonth, 10) &&
      currentDay < parseInt(birthDay, 10))
  ) {
    age--;
  }

  // 返回解析后的信息对象
  return {
    areaCode: areaCode,
    birthDate: `${birthYear}-${birthMonth}-${birthDay}`,
    gender: gender,
    age: age,
  };
}

// 计算BMI
function calculateBMI(height, weight) {
  height = Number(height);
  weight = Number(weight);
  const heightInMeters = height / 100;
  const bmi = weight / (heightInMeters * heightInMeters);
  if (isNaN(bmi)) return "-";
  return bmi.toFixed(2);
}

// 计算体脂率
function calculateBodyFat(height, weight, age, gender) {
  // 计算BMI
  const bmi = calculateBMI(height, weight);

  // 根据性别计算体脂率
  let bodyFat;
  if (gender === 1) {
    bodyFat = 1.2 * bmi + 0.23 * age - 16.2;
  } else if (gender.toLowerCase() === 0) {
    bodyFat = 1.2 * bmi + 0.23 * age - 5.4;
  } else {
    throw new Error("Invalid gender. Please specify 'male' or 'female'.");
  }

  return bodyFat.toFixed(2);
}

// 对象转url路径参数
function objectToQueryString(obj) {
  const queryString = new URLSearchParams();
  Object.keys(obj).forEach((key) => {
    queryString.append(key, obj[key]);
  });
  return queryString.toString();
}

// 清空对象属性值
function clearObjectValues(obj) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (
        typeof obj[key] === "string" ||
        typeof obj[key] === "number" ||
        typeof obj[key] === "boolean"
      ) {
        obj[key] = "";
      } else if (Array.isArray(obj[key])) {
        obj[key] = [];
      } else if (typeof obj[key] === "object" && obj[key] !== null) {
        clearObjectValues(obj[key]); // 递归清空嵌套对象的值
      }
    }
  }
}

/**
 * @desc 根据传入的日期和天数，返回该日期之前的指定天数的日期。
 * @param {string} dateString - 输入的日期字符串，格式为 'YYYY-MM-DD'。
 * @param {number} days - 要减少的天数。
 * @return {string} - 减少指定天数后的日期字符串，格式为 'YYYY-MM-DD'。
 */
function getPreviousDate(dateString, days = 1) {
  // 将日期字符串转换为日期对象
  const date = new Date(dateString);

  // 将日期减少指定的天数
  date.setDate(date.getDate() - days);

  // 格式化日期为字符串
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始，因此需要加1
  const day = String(date.getDate()).padStart(2, "0"); // 确保日是两位数

  // 返回格式化后的日期字符串
  return `${year}-${month}-${day}`;
}

/**
 * 统计对象数组中指定键的值的总和。
 *
 * @param {Array<Object>} arr - 对象数组，每个对象中可能包含多个键值对。
 * @param {string|string[]} keys - 一个或多个需要统计的键。
 * @returns {Object} 返回一个对象，其中包含每个键对应值的总和。
 */
function sumValues(arr, keys) {
  if (typeof keys === "string") {
    keys = [keys];
  }

  return keys.reduce((accumulator, key) => {
    accumulator[key] = arr.reduce((sum, currentObj) => {
      return sum + (currentObj[key] || 0);
    }, 0);
    return accumulator;
  }, {});
}

/**
 * 获取指定日期的上一年对应的日期。
 *
 * @param {string|Date} date - 传入的日期，可以是字符串或Date对象。
 * @returns {string} 返回上一年同一天的日期，格式为 YYYY-MM-DD。
 */
function getPreviousYear(date) {
  const inputDate = new Date(date);
  inputDate.setFullYear(inputDate.getFullYear() - 1);
  const year = inputDate.getFullYear();
  const month = String(inputDate.getMonth() + 1).padStart(2, "0"); // 月份从0开始，所以要加1
  const day = String(inputDate.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/**
 * 将给定的时间字符串和要添加的分钟数相加，返回新的时间字符串。
 * @param {string} time - 以 "HH:mm" 格式表示的时间字符串，例如 "11:40"。
 * @param {number} minutesToAdd - 要添加的分钟数，例如 20。
 * @returns {string} - 新的时间字符串，格式为 "HH:mm"。
 */
function addMinutes(time, minutesToAdd) {
  const [hours, minutes] = time.split(":").map(Number);
  const totalMinutes = hours * 60 + minutes + minutesToAdd;
  const newHours = Math.floor(totalMinutes / 60) % 24; // 使用 % 24 确保小时数在 0-23 之间
  const newMinutes = totalMinutes % 60; // 计算分钟数
  return `${String(newHours).padStart(2, "0")}:${String(newMinutes).padStart(
    2,
    "0"
  )}`;
}

export {
  filterEmptyStrings,
  useCurrentDateTime,
  scrollIntoView,
  formatDate,
  parseIDCard,
  calculateBMI,
  calculateBodyFat,
  getDaysBetweenDates,
  objectToQueryString,
  clearObjectValues,
  getPreviousDate,
  getDayOfWeek,
  sumValues,
  getPreviousYear,
  addMinutes,
  addDaysToDate,
};
